import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {

// 开发模式-ajax-URL
  //   // Banner
  //   axiosGoogleUrl: '/api/index.php?c=user&a=googleverification',
  //   axiosGetUrl: '/api/index.php?c=user&a=login',
  //   // ResetPass
  //   axiosPassVerificationUrl: '/api/index.php?c=user&a=forget_password&action=getCode',
  //   axiosPassUrl: '/api/index.php?c=user&a=forget_password&action=reset_password',
  //   // Phone
  //   axiosVerificationUrl: '/api/index.php?c=user&a=register&do=send_sms_code',
  //   axiosEmailUrl:'/api/index.php?c=user&a=registera_part2&op=jc',
  //   axiosResetEmailUrl: '/api/index.php?c=user&a=registera_part2&op=sc',
  //   axiosNextUrl: '/api/index.php?c=user&a=registera_part2&op=sc',
  //   axiosThreeUrl: '/api/index.php?c=user&a=register&do=register3',
  //   axiosAuditSendUrl: '/api/index.php?c=user&a=registera_part2&op=sendCheck',
  //   axiosAuthenticationUrl: '/api/index.php?c=user&a=registera_part2&op=cj',
  //   // 忘記交易密碼：
  //   axiosPasswordUrl: '/api/index.php?c=tyg_account&a=forgot_trader_password',
	// 	  // 忘記登录密碼：
	// 	axiosloginPasswordUrl: '/api/index.php?c=tyg_account&a=forgot_login_password',
  //   // 等待審核-驗證碼
  //   axiosAuditVerificationUrl: '/api/index.php?c=tyg_index&a=agreement',
  //   // 登入login
  //   axiosLoginUrl: '/api/index.php?c=tyg_index&a=center_index',
  //   // login下銀行修改：
  //   axiosLoginBankUrl: '/api/index.php?c=tyg_index&a=agreement&op=fy_branch',
  //   axiosLoginBankSubUrl: '/api/index.php?c=tyg_index&a=agreement&op=fy_branch_status',

  //   // 交易中心
  //   axiosIndentUrl: '/api/index.php?c=tyg_trader&a=order&op=getdata',
  //   // 交易中心 下 -> 交易訂單
  //   axiosDetailsUrl: '/api/index.php?c=tyg_trader&a=order&op=details',
  //   axiosSelectUrl: '/api/index.php?c=tyg_trader&a=order&op=select',
  //   axiosInquireUrl: '/api/index.php?c=tyg_trader&a=order&op=getdata',
  //   // 交易中心 下 ->  資金帳單
  //   axiosMoneyBillsUrl: '/api/index.php?c=tyg_trader&a=capital_bill',
  //   // 交易中心 下 ->  提現/轉出記錄  轉出/轉入記錄
  //   axiosRecordUrl: '/api/index.php?c=tyg_trader&a=capital_record',
  //   axiosRecordDetailsUrl: '/api/index.php?c=tyg_trader&a=capital_record&id=2&do=details',
  //   // 交易中心 下 -> 交易帳單
  //   axiosbillsUrl: '/api/index.php?c=tyg_trader&a=trading_bill',
  //   // 交易中心 下 ->  儲值╱轉入
  //   axiosShiftUrl: '/api/index.php?c=tyg_trader&a=deposit_in_ok',
  //   // 交易中心 下 ->  提現╱轉出
  //   axiosRolloffUrl: '/api/index.php?c=tyg_trader&a=withdraw_ok',
  //   // 交易中心 下 ->  流水
  //   axiosStatementUrl: '/api/index.php?c=tyg_trader&a=capital_flow',
  //   // 交易中心 下 ->  提领管理
  //   axiosqueryUrl: '/api/index.php?c=tyg_trader&a=settled_query',
	// 	 // 交易中心 下 ->  電子憑證
	// 	axioscertificUrl: '/api/index.php?c=tyg_trader&a=electronic_certificate',
  //   // 交易中心 下 ->  凍結資金
  //   axiosFreezeUrl: '/api/index.php?c=tyg_trader&a=frozen_funds',
  //   axiosFreezeDetailsUrl: '/api/index.php?c=tyg_trader&a=frozen_funds&op=details',
  //   //應用中心
  //   axiosGetApplicationCoreUrl: '/api/index.php?c=home&a=welcome&do=system&',
  //   //account
  //   axiosPersonalUrl:'/api/index.php?c=tyg_account&a=personal_info&',
	// 	//个人资讯-操作记录
  //   axiosOperateUrl:'/api/index.php?c=tyg_account&a=personal_info&op=log',
	// 	// 预留资讯
  //   axiosReserveUrl:'/api/index.php?c=tyg_account&a=reserved_info',
	// 	// 商家资讯
  //   axiosBusinessUrl:'/api/index.php?c=tyg_account&a=seller_info&',
  //   // 商家资讯 - 结算资讯
  //   axiosBusinessSettlementUrl: '/api/index.php?c=tyg_account&a=change_admin',
  //   axiosBusinessSettlementOpUrl: '/api/index.php?c=tyg_account&a=change_admin&op=change',
	// 	// 谷歌验证码
  //   axiosSecurityUrl:'/api/index.php?c=tyg_account&a=safety_bingding&',
	// 	// 首页
  //   axiosxxxxUrl:'/api/index.php?c=tyg_account&a=center_index&',
  //   //登出
  //   axiosLoginOutUrl:'/api/index.php?c=user&a=logout',
  //   // Agreement 設定安全資訊:
  //   axiossubmitForm: '/api/index.php?c=tyg_index&a=agreement&',
  //   // 設定結算週期&日期:
  //   axiossetwithdrawForm: '/api/index.php?c=tyg_index&a=set_settled_period',
  //   //使用協議  更新  參數uid
  //   axiosUseStatusUpdateUrl:'/api/index.php?c=user&a=use_status&op=update&uid=',
  //   //帮助中心
  //   axiosHelpUrl:'/api/index.php?c=help&a=display&',
	// 	//綁定api接口
	// 	axiosapigenerate: '/api/index.php?c=tyg_account&a=api_safety&op=generate',
  //   axiossubmitlist: '/api/index.php?c=tyg_account&a=safety_bingding&op=change',
  //   axiossubmitsafet: '/api/index.php?c=tyg_account&a=api_safety',
  //   axiossubmitstanadd: '/api/index.php?c=tyg_account&a=api_safety&op=add',
  //   axiosforbidden: '/api/index.php?c=tyg_account&a=api_safety&op=del',

	// 	// 修改登录密码
  // 	axiossubmitPass:'/api/web/index.php?c=tyg_account&a=login_password',
  //   //修改交易密码
  //   axiossubmitPasstr:'/api/index.php?c=tyg_account&a=trader_password',
	// 	// 修改邮箱
	//     axiosemail:'/api/index.php?c=tyg_account&a=change_email',
	// 	//手机验证码
	// 	axiosPhone:'/api/index.php?c=tyg_account&a=change_account&op=send_sms_code',
	// 	// 操作记录下载
	//     axiosxlsUrl: '/api/index.php?c=tyg_account&a=personal_info&op=log',
	// 	// 安全綁定-增強ip
	// 	axiosipbind:'/api/index.php?c=tyg_account&a=safety_bingding&op=ipbind',
	// 	// 安全綁定-刪除ip
  //   axiosipdel:'/api/index.php?c=tyg_account&a=safety_bingding&op=ip_del',
  //   // 產品中心
  //   axiosCatalogueUrl: '/api/index.php?c=tyg_product&a=configuration',
  //   axiosAddCatalogueUrl: '/api/index.php?c=tyg_product&a=configuration&op=add',
  //   axiosDelCatalogueUrl: '/api/index.php?c=tyg_product&a=configuration&op=del',
	// // 数据中心-实时数据
	// axiosDatatimeurl: '/api/index.php?c=tyg_data&a=real_data',
	// // 数据中心-历史数据
  // axiosDataLstimeurl: '/api/index.php?c=tyg_data&a=history_data',
  // // 帮助中心：
  // axiosAutoHelpUrl: '/api/index.php?c=help&a=help_center',
  // // 平台公告：
  // axiosNoticeUrl: '/api/index.php?c=tyg_index&a=notice',


  // // 【测试模板】
  // axiosTestUrl: '/api/app/index.php?i=1&c=site&a=site&do=get_article',
		


    

    // 线上模式-ajax-URL
    // Banner
    axiosGoogleUrl: '/web/index.php?c=user&a=googleverification',
    axiosGetUrl: '/web/index.php?c=user&a=login',
    // ResetPass
    axiosPassVerificationUrl: '/web/index.php?c=user&a=forget_password&action=getCode',
    axiosPassUrl: '/web/index.php?c=user&a=forget_password&action=reset_password',
    // Phone
    axiosVerificationUrl: '/web/index.php?c=user&a=register&do=send_sms_code',
    axiosEmailUrl:'/web/index.php?c=user&a=registera_part2&op=jc',
    axiosResetEmailUrl: '/web/index.php?c=user&a=registera_part2&op=sc',
    axiosNextUrl: '/web/index.php?c=user&a=registera_part2&op=sc',
    axiosThreeUrl: '/web/index.php?c=user&a=register&do=register3',
    axiosAuditSendUrl: '/web/index.php?c=user&a=registera_part2&op=sendCheck',
    axiosAuthenticationUrl: '/web/index.php?c=user&a=registera_part2&op=cj',
    // 忘記交易密碼：
    axiosPasswordUrl: '/web/index.php?c=tyg_account&a=forgot_trader_password',
		  // 忘記登录密碼：
		axiosloginPasswordUrl: '/web/index.php?c=tyg_account&a=forgot_login_password',
    // 等待審核-驗證碼
    axiosAuditVerificationUrl: '/web/index.php?c=tyg_index&a=agreement',
    // 登入login
    axiosLoginUrl: '/web/index.php?c=tyg_index&a=center_index',
    // login下銀行修改：
    axiosLoginBankUrl: '/web/index.php?c=tyg_index&a=agreement&op=fy_branch',
    axiosLoginBankSubUrl: '/web/index.php?c=tyg_index&a=agreement&op=fy_branch_status',
    // 交易中心
    axiosIndentUrl: '/web/index.php?c=tyg_trader&a=order&op=getdata',
    // 交易中心 下 -> 交易訂單
    axiosSelectUrl: '/web/index.php?c=tyg_trader&a=order&op=select',
    axiosInquireUrl: '/web/index.php?c=tyg_trader&a=order&op=getdata',
    axiosDetailsUrl: '/web/index.php?c=tyg_trader&a=order&op=details',
    // 交易中心 下 ->  充值订单
    axiosRechargeUrl: '/web/index.php?c=tyg_trader&a=order&op=recharge_order',
    axiosInquireUrl1: '/web/index.php?c=tyg_trader&a=order&op=recharge_order',
    // 交易中心 下 ->  資金帳單
    axiosMoneyBillsUrl: '/web/index.php?c=tyg_trader&a=capital_bill',
    // 交易中心 下 ->  提現/轉出記錄
    axiosRecordUrl: '/web/index.php?c=tyg_trader&a=capital_record',
    axiosRecordDetailsUrl: '/web/index.php?c=tyg_trader&a=capital_record&id=2&do=details',
    // 交易中心 下 -> 交易帳單
    axiosbillsUrl: '/web/index.php?c=tyg_trader&a=trading_bill',
    // 交易中心 下 ->  儲值╱轉入
    axiosShiftUrl: '/web/index.php?c=tyg_trader&a=deposit_in_ok',
    // 交易中心 下 ->  提現╱轉出
    axiosRolloffUrl: '/web/index.php?c=tyg_trader&a=withdraw_ok',
    // 交易中心 下 ->  流水
    axiosStatementUrl: '/web/index.php?c=tyg_trader&a=capital_flow',
    // 交易中心 下 ->  提领管理
    axiosqueryUrl: '/web/index.php?c=tyg_trader&a=settled_query',
		//  交易中心 下 ->  電子憑證
		axioscertificUrl: '/web/index.php?c=tyg_trader&a=electronic_certificate',
    // 交易中心 下 ->  凍結資金
    axiosFreezeUrl: '/web/index.php?c=tyg_trader&a=frozen_funds',
    axiosFreezeDetailsUrl: '/web/index.php?c=tyg_trader&a=frozen_funds&op=details',
    //應用中心
    axiosGetApplicationCoreUrl: '/web/index.php?c=home&a=welcome&do=system&',
    //account
    axiosPersonalUrl:'/web/index.php?c=tyg_account&a=personal_info&',
		//个人资讯-操作记录
    axiosOperateUrl:'/web/index.php?c=tyg_account&a=personal_info&op=log',
		// 预留资讯
    axiosReserveUrl:'/web/index.php?c=tyg_account&a=reserved_info',
		// 商家资讯
    axiosBusinessUrl:'/web/index.php?c=tyg_account&a=seller_info&',
    // 商家资讯 - 结算资讯
    axiosBusinessSettlementUrl: '/web/index.php?c=tyg_account&a=change_admin',
    axiosBusinessSettlementOpUrl: '/web/index.php?c=tyg_account&a=change_admin&op=change',
		// 谷歌验证码
    axiosSecurityUrl:'/web/index.php?c=tyg_account&a=safety_bingding&',
		// 首页
    axiosxxxxUrl:'/web/index.php?c=tyg_account&a=center_index&',
    //登出
    axiosLoginOutUrl:'/web/index.php?c=user&a=logout&',
    // Agreement 設定安全資訊:
    axiossubmitForm: '/web/index.php?c=tyg_index&a=agreement&',
    // 設定結算週期&日期:
    axiossetwithdrawForm: '/web/index.php?c=tyg_index&a=set_settled_period',
    //使用協議  更新  參數uid
    axiosUseStatusUpdateUrl:'/web/index.php?c=user&a=use_status&op=update&uid=',
    //帮助中心
    axiosHelpUrl:'/web/index.php?c=help&a=display&',
		//綁定api接口
		axiosapigenerate: '/web/index.php?c=tyg_account&a=api_safety&op=generate',
    axiossubmitlist: '/web/index.php?c=tyg_account&a=safety_bingding&op=change',
    axiossubmitsafet: '/web/index.php?c=tyg_account&a=api_safety',
    axiossubmitstanadd: '/web/index.php?c=tyg_account&a=api_safety&op=add',
    axiosforbidden: '/web/index.php?c=tyg_account&a=api_safety&op=del',
		// 修改登录密码
  	axiossubmitPass:'/web/index.php?c=tyg_account&a=login_password',
    //修改交易密码
    axiossubmitPasstr:'/web/index.php?c=tyg_account&a=trader_password',
		// 修改邮箱
	  axiosemail:'/web/index.php?c=tyg_account&a=change_email',
		//手机验证码
		axiosPhone:'/web/index.php?c=tyg_account&a=change_account&op=send_sms_code',
		// 操作记录下载
	  axiosxlsUrl: '/web/index.php?c=tyg_account&a=personal_info&op=log',
		// 安全綁定-增強ip
		axiosipbind:'/web/index.php?c=tyg_account&a=safety_bingding&op=ipbind',
		// 安全綁定-刪除ip
    axiosipdel:'/web/index.php?c=tyg_account&a=safety_bingding&op=ip_del',
    // 產品中心
    axiosCatalogueUrl: '/web/index.php?c=tyg_product&a=configuration',
    axiosAddCatalogueUrl: '/web/index.php?c=tyg_product&a=configuration&op=add',
    axiosDelCatalogueUrl: '/web/index.php?c=tyg_product&a=configuration&op=del',

	// 数据中心-实时数据
	axiosDatatimeurl:'/web/api/web/index.php?c=tyg_data&a=real_data',
	// 数据中心-历史数据
  axiosDataLstimeurl:'/web/api/web/index.php?c=tyg_data&a=history_data',
  // 帮助中心：
  axiosAutoHelpUrl: '/web/index.php?c=help&a=help_center',
  // 平台公告：
  axiosNoticeUrl: '/web/index.php?c=tyg_index&a=notice',


  // 【测试模板】
  axiosTestUrl: '/app/index.php?i=1&c=site&a=site&do=get_article',


   
    
    // 全局變量

    // 用戶名uid
    uid: sessionStorage.getItem('uid') || '12',
    // 负责人姓名
    principal: localStorage.getItem('principal') || '',
    // 商家简称
    storename: localStorage.getItem('storename') || 'xxx',
    // 是否第一次登入(0, 1) -> Agreement
    agreement: localStorage.getItem('agreement') || '0',
    // 交易中心是否能點(-1, 1)
    dealTF: localStorage.getItem('dealTF') || '1',
    // 设置提现选择：
    settledTF: localStorage.getItem('settledTF') || '0',
    // 預留資訊
    reserved: localStorage.getItem('reserved') || '',
    // 是否有谷歌
    secretTF: localStorage.getItem('secretTF') || -1,
    // 谷歌秘钥的值
    secretVal: localStorage.getItem('secretVal') || '',
    // 手机号
    telephone: localStorage.getItem('telephone') || -1,
    // 是否有交易密码
    traderPassTF: localStorage.getItem('traderPassTF') || -1,
    // 銀行修改狀態：0-不显示，1-显示等待，2-显示输入：
    branchChange: localStorage.getItem('branchChange') || 0,
    // 等待审核
    auditShow: "wait",
    waitShow: true,
    number: null,
    // 登入时 -> 注册状态保存
    stage: null,
    // 登入时 -> 注册状态 资料保存
    registerList: [],
    // 訂單詳情 -> 數組
    detailsList: {},
    // 是否是管理员
    is_agent: 0,

    // 資金帳單-時間：
    dateVal: [], 
    dateValTF: localStorage.getItem('dateValTF') || '0',
    dateValUid: '',
    dateValType: '',
    FPnumber: '/',
    navTF: true,

    // 【注意：】用于测试
    ceshi:'我是title',
  },
  mutations: {
    // FUN-登入驗證
    changeUid(state, uid){
      // 預留資訊
      state.reserved = uid.reserved;
      localStorage.setItem('reserved', uid.reserved);
      // 是否有谷歌秘钥
      state.secretTF = uid.secretTF;
      localStorage.setItem('secretTF', uid.secretTF);
      // 谷歌秘钥的值
      state.secretVal = uid.secretVal;
      localStorage.setItem('secretVal', uid.secretVal);
      // 设置提现选择：
      state.settledTF = uid.settledTF;
      localStorage.setItem('settledTF', uid.settledTF);
      // 交易中心是否能點:
      state.dealTF = uid.dealTF;
      localStorage.setItem('dealTF', uid.dealTF);
      // 是否有手机号
      state.telephone = uid.telephone;
      localStorage.setItem('telephone', uid.telephone);
      // 是否有交易密码
      state.traderPassTF = uid.traderPassTF;
      localStorage.setItem('traderPassTF', uid.traderPassTF);
      // 用戶名uid
      state.uid = uid.uid;
      sessionStorage.setItem('uid', uid.uid);
      // 是否第一次登入
      state.agreement = uid.agreement;
      localStorage.setItem('agreement', uid.agreement);
      // 銀行修改狀態：
      state.branchChange = uid.branchChange;
      localStorage.setItem('branchChange', uid.branchChange);
      // 负责人姓名
      state.principal = uid.principal;
      localStorage.setItem('principal', uid.principal);
      // 是否是管理员
      state.is_agent = uid.is_agent;
      localStorage.setItem('is_agent', uid.is_agent);
    },
    // 登出
    changeQuit(state, uidTF){
      
    },
    // FUN-商家简称
    changePrincipal(state, principal){
      // 负责人姓名
      state.principal = principal.principal;
      localStorage.setItem('principal', principal.principal);
      // 商家简称
      state.storename = principal.storename;
      localStorage.setItem('storename', principal.storename);
    },
    // FUN-等待审核
    changeAudit(state, audit){
      state.auditShow = audit.auditShow;
      state.waitShow = audit.waitShow;
      
    },
    // FUN-等待審核 -> 4位數字驗證碼
    changeAuditnumber(state, number){
      state.number = number;
    },
    // FUN-修改第一次登入
    changeAgreement(state, agreement){
      state.agreement = agreement;
    },
    // FUN-登入-注册状态跳转保存
    changeRegister(state, register){
      state.stage = register.stage;
      state.registerList = register.registerList;
    },
    // FUN-訂單詳情
    changeDetails(state, details){
      state.detailsList = details;
    },
    // FUN-資金帳單時間
    changeDateVal(state, dateVal){
      state.dateVal = dateVal;
    },
    // FUN-是否資金帳單
    changeDateValTF(state, dateValTF){
      state.dateValTF = dateValTF.trueTF;
      localStorage.setItem('dateValTF', dateValTF.trueTF);
      state.dateValUid = dateValTF.uid;
      state.dateValType = dateValTF.type;
    },
    // 修改密碼返回：
    changeFP(state, number){
      state.FPnumber = number;
    },
    // FUN-銀行修改狀態：
    changeBank(state, number){
      state.branchChange = number;
      localStorage.setItem('branchChange', number);
    },
		reservedFun(state, reserved){
		  // 預留資訊
			state.reserved = reserved;
			localStorage.setItem('reserved', reserved);
		},
    // FUN-【注意：】用于测试
    changeCS(state, ceshi){
      state.ceshi = ceshi;
    }
  },
  actions: {
    // changeUid(ctx, uid){
    //   ctx.commit("changeUid", uid)
    // }
  }
})
